import { parseRequestMetaData } from './parseRequestMetaData';
import { ApiRequest, ApiResponse, ApiServiceClient } from './types';

type ApiRouteHandlerOptions = {
  apiServiceClient: ApiServiceClient;
};

type ApiRoutHandler = (req: ApiRequest, res: ApiResponse) => Promise<void>;

export const createApiRouteHandler = (options: ApiRouteHandlerOptions): ApiRoutHandler => {
  const defaultApiClient: ApiServiceClient = {
    async sendEvent() {
      console.warn('ApiServiceClient required to process API route data');
    },
  };
  const apiServiceClient = options?.apiServiceClient || defaultApiClient;

  const apiRouteHandler: ApiRoutHandler = async (
    req: ApiRequest,
    res: ApiResponse
  ): Promise<void> => {
    if (req.method !== 'POST') {
      return res.status(405).json({
        status: 'error',
        message: 'Only POST requests allowed',
      });
    }

    if (!req.body || typeof req.body !== 'object') {
      return res.status(403).json({
        status: 'error',
        message: 'No data/invalid data. Data should be in JSON format',
      });
    }

    try {
      const bodyData = req.body ?? {};
      const data = Object.assign({}, parseRequestMetaData(req), bodyData);
      await apiServiceClient.sendEvent(data);
      return res.status(201).json({ status: 'success' });
    } catch (error) {
      return res.status(500).json({
        status: 'error',
        message: error instanceof Error ? error.message : 'Error sending event',
      });
    }
  };
  return apiRouteHandler;
};
